export const INITIAL_HOME_DATA = {
  header: {
    title: "26Minutes Ministry",
    logo: "/logo192.png"
  },
  footer: {
    address: "123 Faith Street, City, Country",
    phone: "(555) 123-4567",
    contactInfo: "info@26minutesministry.org"
  },
  hero: {
    images: [],
    text: "Welcome to 26Minutes Ministry"
  },
  snippets: {
    about: {
      title: "About Us",
      content: "Empowering individuals to know, live, and share the Word of God.",
      image: ""
    },
    news: {
      show: true,
      title: "Latest News"
    },
    workshop: {
      title: "Workshops",
      content: "Join our interactive workshops to deepen your understanding.",
      image: ""
    },
    outreach: {
      title: "Community Outreach",
      content: "Serving our local community with love and compassion.",
      image: ""
    },
    donate: {
      title: "Support Our Mission",
      content: "Your generous contribution helps us continue our work.",
      image: ""
    },
    contact: {
      title: "Get in Touch",
      content: "We would love to hear from you. Reach out to us for any inquiries."
    }
  }
};
